// extracted by mini-css-extract-plugin
export default {"button":"cn-z","reviewSort":"dn-z"};